import React from 'react';
import classes from './AuctionContent.module.scss';
import Loading from '../Layout/Loading';
import EmptyContentCard from '../Layout/EmptyContentCard';
import { Button, Tooltip } from '@chakra-ui/react';
import { formatDate, formatDateWithTime } from '../../helper/utils';
import FilterAccordion from './FilterAccordion';
import SavedSearches from './SavedSearches';
import { auctionSavedSearchAdapter, auctionCurrentSearch } from './auctionSavedSearches';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import placeholderImage from '../../media/images/emptyFavorites.png';

const DesktopAuctionContent = (props) => {
  const { 
    muiTheme, 
    filterAnimationState, 
    isDesktopFilterOpen, 
    onClickFilterHandler,
    selectedSavedSearchFilter,
    setSelectedSavedSearchFilter, 
    savedSearchFilters, 
    setSavedSearchFilters, 
    filterString, 
    filterHandler, 
    clearCarList, 
    carFiltersList, 
    scheduleDay, 
    filterParameters, 
    totalCars, 
    viewMode, 
    handleViewModeChange, 
    sortBy, 
    setSortBy, 
    scrollContainerRef, 
    handleScroll, 
    initialLoading, 
    carsData, 
    loading, 
    page, 
    setPage, 
    onCardClickHandler, 
    onClickFavouriteHandler, 
    getCarName, 
    localFavorites,
    userData,
    isFreeTier,
    searchText,
    onClearSearch,
    onApplySavedSearch
  } = props;

  // Desktop view JSX will go here
  return (
    <div className={classes.ActionContent}>
      <div 
        className={classes.filterOpenerContainer}
        style={{ display: !isDesktopFilterOpen ? "block" : "none" }}
      >
        <div className={classes.filterHeaderTitleOpener}>
          <button
            className={classes.openButton}
            onClick={onClickFilterHandler}
          >
            <i className="fas fa-chevron-right"></i>      
          </button>
        </div>
      </div>

      <MUIThemeProvider theme={muiTheme}>
        <div 
          className={`${classes.filter} ${filterAnimationState ? classes[filterAnimationState] : ''}`}
          style={{
            display: isDesktopFilterOpen ? "block" : "none",
            marginRight: isDesktopFilterOpen ? "16px" : "0"
          }}
        >
          <div className={classes.filterHeader}>
            <div className={classes.filterHeaderTitle}>
              <button
                className={classes.closeButton}
                onClick={onClickFilterHandler}
              >
                <i className="fas fa-chevron-left"></i>      
              </button>
              <i className="fas fa-filter"></i>
              <h3>Filters</h3>
            </div>
          </div>
          <FilterAccordion
            scheduleDay={scheduleDay}
            carFiltersList={carFiltersList}
            items={filterParameters}
            filterString={filterString}
            setFilterString={filterHandler}
            reloadCarList={clearCarList}
            selectedSavedSearchFilter={selectedSavedSearchFilter}
            setSelectedSavedSearchFilter={setSelectedSavedSearchFilter}
            searchText={searchText}
            onClearSearch={onClearSearch}
            savedSearchesSlot={
              <SavedSearches
                savedSearches={savedSearchFilters}
                setSavedSearches={setSavedSearchFilters}
                adapter={auctionSavedSearchAdapter}
                current={auctionCurrentSearch(filterString, searchText)}
                onApply={onApplySavedSearch}
              />
            }
          />
        </div>
      </MUIThemeProvider>

      {/* Auction Cars Container */}
      <div className={classes.auctionCarsContainer}>
        <div className={classes.auctionCarsHeader}>
          <h1>
            {totalCars > 0 ? `${totalCars} ${totalCars === 1 ? 'vehicle' : 'vehicles'} found` : 'No vehicles found'}
          </h1>
          <div className={classes.headerControls}>
              <div className={classes.viewToggle}>
                  <Tooltip label="Grid View" placement="top">
                      <Button 
                          variant={viewMode === 'grid' ? 'solid' : 'outline'} 
                          colorScheme="blue" 
                          size="sm" 
                          onClick={() => handleViewModeChange('grid')}
                          marginRight="8px"
                      >
                          <i className="fas fa-th-large"></i>
                      </Button>
                  </Tooltip>
                  <Tooltip label="List View" placement="top">
                      <Button 
                          variant={viewMode === 'list' ? 'solid' : 'outline'} 
                          colorScheme="blue" 
                          size="sm" 
                          onClick={() => handleViewModeChange('list')}
                          marginRight="16px"
                      >
                          <i className="fas fa-list"></i>
                      </Button>
                  </Tooltip>
              </div>
              <div className={classes.auctionCarsHeaderSort}>
                  <p>Sort by:</p>
                  <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} >
                    <option value="default">Default (Newest)</option>
                    <option value="km">Km (Lowest)</option>
                    <option value="kmDesc">Km (Highest)</option>
                    <option value="bidDate">Bidding Date (Earliest)</option>
                    <option value="bidDateDesc">Bidding Date (Latest)</option>
                    <option value="grade">Grade (Highest)</option>
                    <option value="gradeDesc">Grade (Lowest)</option>
                    <option value="bidNo">Bid No (Lowest)</option>
                    <option value="bidNoDesc">Bid No (Highest)</option>
                  </select>
              </div>
          </div>
        </div>

        {/* Desktop Grid View */} 
        {viewMode === 'grid' && (
          <div className={`${classes.auctionCars} ${!isDesktopFilterOpen ? classes.filterClosed : ''}`}
            ref={scrollContainerRef} 
          >
            {initialLoading ? (
                <div className={classes.loadingContainer}>
                    <Loading text="Cars" />
                </div>
            ) : carsData.length > 0 ? (
              <>
                {carsData.map((content, index) => (
                  <div 
                      key={index} 
                      className={classes.auctionCard} 
                      onClick={() => onCardClickHandler(content)}
                  >
                      <div className={classes.carImageContainer}>
                          <div className={`${classes.favCarIcon} ${(content?.isFavorite || localFavorites.has(content._id)) && classes.isFav}`}
                              onClick={(e) => {
                                  e.stopPropagation();
                                  onClickFavouriteHandler(content);
                              }}>
                                  {(content?.isFavorite || localFavorites.has(content._id)) ? 
                                      <i className="fas fa-heart"></i> : 
                                      <i className="far fa-heart"></i>
                                  }
                              </div>
                          <img 
                              src={content.vehicleImages && content.vehicleImages.length > 0 ? content.vehicleImages[0] : placeholderImage} 
                              alt="car"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = placeholderImage;
                              }}
                          />
                          <div className={classes.Bid}>
                              <p>Bid No: {(content.bidNo || '').replace(/^No\./, '')}</p>
                          </div>
                      </div>
                      <div className={classes.cardTextContent}>
                          <div className={classes.kmDiv}>
                              <p>● {content.mileage}</p>
                          </div>
                          <h3>{getCarName(content)}</h3>
                          <div className={classes.auctionCarDetails}>
                              <div className={classes.auctionCarText}>
                                  <div className={classes.IconContainer}>
                                      <i className="far fa-star"></i>
                                  </div>
                                  <p>Grade:</p> 
                                  <span>{content.inspectionScore || "none"}</span>
                              </div>
                              <div className={classes.auctionCarText}>
                                  <div className={classes.IconContainer}>
                                      <i className="fas fa-gavel"></i>
                                  </div>
                                  <p>Auction:</p>
                                  <span>{content.bidDetail?.bidSite}</span>
                              </div>
                              <div className={classes.auctionCarText}>
                                  <div className={classes.IconContainer}>
                                      <i className="far fa-calendar"></i>
                                  </div>
                                  <p>Bidding Date:</p>
                                  <span>{formatDate(content.bidDetail?.bidDate)}</span>
                              </div>
                              <div className={classes.auctionCarText}>
                                  <div className={classes.IconContainer}>
                                      <i className="fas fa-cog"></i>
                                  </div>
                                  <p>Transmission:</p>
                                  <span>{content.engineDetail.transmission}</span>
                              </div>
                          </div>
                      </div>
                  </div>
                ))}
                {loading && (
                  <div className={classes.paginationLoadingContainer}>
                    <Loading text="Loading more" />
                  </div>
                )}
                {/* No Load More button for desktop infinite scroll */}
              </>
            ) : (
              <div className={classes.loadingContainer}>
                <EmptyContentCard header="No Cars Available" message="Looks like there are no results for this search query"/>
              </div>
            )}
          </div>
        )}

        {/* Desktop List View */} 
        {viewMode === 'list' && (
          <div className={classes.auctionList} 
            ref={scrollContainerRef} 
            onScroll={handleScroll}
            style={{ 
                height: 'auto',
                maxHeight: 'none',
                overflowY: 'visible',
                paddingBottom: '20px'
            }}
          >
            <div className={classes.listHeader}>
              <div className={classes.photoCell}>Photo</div>
              <div className={classes.lotNumberCell}>Lot #</div>
              <div className={classes.yearChassisCell}>Year Model</div>
              <div className={classes.engineCell}>Make</div>
              <div className={classes.mileageCell}>Mileage</div>
              <div className={classes.auctionDateCell}>Auction Date</div>
              <div className={classes.gradeCell}>Grade</div>
              <div className={classes.transmissionCell}>Transmission</div>
            </div>
            
            {initialLoading ? (
              <div className={classes.loadingContainer}><Loading text="Cars" /></div>
            ) : carsData.length > 0 ? (
              <>
                {carsData.map((content, index) => (
                  <div key={index} className={classes.listRow} onClick={() => onCardClickHandler(content)}>
                    <div className={classes.photoCell}>
                        <img 
                            src={content.vehicleImages && content.vehicleImages.length > 0 ? content.vehicleImages[0] : placeholderImage} 
                            alt={getCarName(content)} 
                            className={classes.listThumbnail}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = placeholderImage;
                            }}
                        />
                    </div>
                    <div className={classes.lotNumberCell}>{(content.bidNo || '').replace(/^No\./, '')}</div>
                    <div className={classes.yearChassisCell}>{getCarName(content)}</div>
                    <div className={classes.engineCell}>{content.makerDetail.maker}</div>
                    <div className={classes.mileageCell}>{content.mileage}</div>
                    <div className={classes.auctionDateCell}>
                        {userData && !isFreeTier ? 
                            formatDateWithTime(content.bidDetail?.bidDate, content.auctionTime) : 
                            formatDate(content.bidDetail?.bidDate)
                        }
                    </div>
                    <div className={classes.gradeCell}>{content.inspectionScore || "N/A"}</div>
                    <div className={classes.transmissionCell}>{content.engineDetail.transmission}</div>
                  </div>
                ))}
                {loading && (
                  <div className={classes.paginationLoadingContainer}>
                    <Loading text="Loading more" />
                  </div>
                )}
                {/* Add Load More button for desktop list view? (Or keep infinite scroll?) */}
                {!loading && carsData.length > 0 && carsData.length < totalCars && (
                    <div className={classes.loadMoreButtonContainer}>
                        <Button
                            colorScheme="purple"
                            size="md"
                            onClick={() => setPage(page + 1)}
                            isLoading={loading}
                            loadingText="Loading"
                            width="200px"
                            margin="20px auto"
                            bgColor="#4A0CB6"
                            color="white"
                            _hover={{ bgColor: "#7D61F0" }}
                            fontFamily="Inter, sans-serif"
                        >
                            Load More ({carsData.length} of {totalCars})
                        </Button>
                    </div>
                )}
              </>
            ) : (
              <div className={classes.loadingContainer}>
                  <EmptyContentCard header="No Cars Available" message="Looks like there are no results for this search query"/>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DesktopAuctionContent; 